export enum TodoOverviewSortOrder {
  Name = 0,
  TodoCount = 1,
  Overdue = 2,
}
